export default function usePRFileTree() {
  const normalizePath = (p) => (p || '').toString().replace(/\\/g, '/').replace(/\s+/g, ' ').trim();

  const buildFileTree = (files) => {
    const root = { name: '', path: '', children: {} };
    (files || []).forEach((f) => {
      const full = normalizePath(f.path || f.filename || '');
      const parts = full.split('/').filter(Boolean);
      let node = root;
      parts.forEach((part, idx) => {
        const isLeaf = idx === parts.length - 1;
        const childPath = node.path ? `${node.path}/${part}` : part;
        if (!node.children[part]) node.children[part] = { name: part, path: childPath, children: {}, file: null };
        node = node.children[part];
        if (isLeaf) node.file = f;
      });
    });
    return root;
  };

  const getAllFilePathsFromTree = (root) => {
    const results = [];
    if (!root || !root.children) return results;
    const isDir = (node) => Object.keys(node.children || {}).length > 0 && !node.file;
    const traverse = (node) => {
      const entries = Object.values(node.children || {}).sort((a, b) => {
        const aIsDir = isDir(a);
        const bIsDir = isDir(b);
        if (aIsDir !== bIsDir) return aIsDir ? -1 : 1;
        return a.name.localeCompare(b.name);
      });
      for (const child of entries) {
        if (isDir(child)) traverse(child);
        else if (child && child.file) results.push(normalizePath(child.path));
      }
    };
    traverse(root);
    return results;
  };

  return { normalizePath, buildFileTree, getAllFilePathsFromTree };
}




